import React from "react";

interface CardElementProps {
  title: string;
  value: number | null;
  lastMonthValue: number | null;
  color: string;
}

const CardElement: React.FC<CardElementProps> = ({ title, value, lastMonthValue, color }) => {
  return (
    <div className="bg-white w-full h-20 sm:h-24 md:h-28 lg:h-32 flex flex-col justify-center items-center rounded-md p-1 sm:p-2 shadow-sm">
      {/* Title with responsive sizing and fixed height to prevent vertical shift */}
      <div className="flex h-8 sm:h-10 md:h-12 justify-center items-center px-1">
        <h2 className="text-xs sm:text-sm md:text-base font-bold text-center leading-tight overflow-hidden line-clamp-2">
          {title}
        </h2>
      </div>

      {/* Number and Last Month line aligned horizontally */}
      <div className="flex flex-col items-center justify-center flex-1 min-h-0">
        {/* Number centered vertically with responsive sizing */}
        <p 
          style={{ color: `#${color}` }} 
          className="font-bold text-sm sm:text-lg md:text-xl lg:text-2xl mb-0.5 sm:mb-1"
        >
          {value !== null ? value.toLocaleString() : "--"}
        </p>
        
        {/* Last Month text below with responsive sizing */}
        <p className="text-[#757575] text-xs sm:text-xs md:text-sm text-center leading-tight">
          Last Month: {lastMonthValue !== null ? lastMonthValue.toLocaleString() : "--"}
        </p>
      </div>
    </div>
  );
};

export default CardElement;